<!-- Main Container -->
<div class="card" style="height: auto">
  <!-- Header -->
  <div class="px-4 py-2 border-b border-gray-200 dark:border-gray-700">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100">
      Advisor Account List
    </h3>
  </div>
    <div kendoWindowContainer></div>
  <div kendoDialogContainer></div>
  <div class="p-4">
    <kendo-grid
      #grid
      [kendoGridBinding]="view"
      [pageSize]="gridState.take"
      [skip]="gridState.skip"
      [sort]="gridState.sort"
      [pageable]="true"
      [resizable]="true"
      [filterable]="true"
      [sortable]="true"
      (dataStateChange)="onStateChange($event)"
      [navigable]="true"
    >
      <kendo-grid-column field="clientId" title="ClientID" [width]="2" [hidden]="true"></kendo-grid-column>
      <kendo-grid-column field="repId" title="ID" [hidden]="true" [width]="2"></kendo-grid-column>
      <kendo-grid-column field="clientTypeId" title="clientTypeId" [width]="2" [hidden]="true"></kendo-grid-column>
      <kendo-grid-column field="branchNumber" title="BranchNumber" [width]="2" [hidden]="true"></kendo-grid-column>
      <kendo-grid-column field="repName" title="Rep Name" [width]="130"></kendo-grid-column>
      <kendo-grid-column field="accountName" title="Account Name" [width]="330"></kendo-grid-column>
      <kendo-grid-column field="firstName" title="First Name" [filterable]="true" [width]="100"></kendo-grid-column>
      <kendo-grid-column field="lastName" title="Last Name" [width]="100"></kendo-grid-column>
      <kendo-grid-column field="city" title="City" [width]="130"></kendo-grid-column>
      <kendo-grid-column field="state" title="State" [width]="80"></kendo-grid-column>
      <kendo-grid-column field="zipCode" title="Zip Code" [width]="80"></kendo-grid-column>

      <kendo-grid-column field="dateEntered" title="Date Entered" format="{0:d}" [width]="100">
        <ng-template kendoGridCellTemplate let-column>
          {{ column.dateEntered | date : 'MM/dd/yyyy' }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="last4Digits" title="TaxID" [width]="80"></kendo-grid-column>

      <kendo-grid-column field="accountOpen" title="Active" [width]="70" filter="boolean">
        <ng-template kendoGridCellTemplate let-dataItem>
          <input type="checkbox" [checked]="dataItem.accountOpen" disabled />
        </ng-template>
      </kendo-grid-column>

      <!-- Action Columns -->
    <!--   <kendo-grid-column [width]="40">
        <ng-template kendoGridCellTemplate let-dataItem>
          <a
            (click)="viewTransactionsList(dataItem.clientId, dataItem.repId)"
            routerLinkActive="router-link-active"
            title="Add a Transaction"
          >
            <ng-icon name="heroDocumentDuplicate" class="text-2xl text-blue-600"></ng-icon>
          </a>
        </ng-template>
      </kendo-grid-column> -->

      <kendo-grid-column [width]="40">
        <ng-template kendoGridCellTemplate let-dataItem>
          <a
            (click)="EditAccount(dataItem.clientId)"
            routerLinkActive="router-link-active"
            title="Edit Client"
          >
            <ng-icon name="heroPencil" class="xl text-blue-600"></ng-icon>
          </a>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column [width]="40">
        <ng-template kendoGridCellTemplate let-dataItem>
          <a
            (click)="viewFiles(dataItem.repId, dataItem.clientId, dataItem.lastName, dataItem.firstName)"
            title="View Files"
            routerLinkActive="router-link-active"
          >
            <ng-icon name="heroFolder" class="xl text-blue-600"></ng-icon>
          </a>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</div>
